import { giphyBlue, giphyGreen, giphyPink, giphyRed, giphyYellow } from '@giphy/colors'

export type Props = {
    className?: string
}

export const CheckIcon = ({ className }: Props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16" className={className}>
        <defs>
            <linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id="uploadcheckicongradient">
                <stop stopColor={giphyGreen} offset="0%" />
                <stop stopColor={giphyBlue} offset="100%" />
            </linearGradient>
        </defs>
        <path
            d="M8 0a8 8 0 110 16A8 8 0 018 0zm3.496 4a.171.171 0 00-.134.06L7.376 8.546 5.638 6.584a.171.171 0 00-.134-.059.171.171 0 00-.134.06L4.057 8.058A.208.208 0 004 8.21c0 .061.019.112.057.151l3.183 3.58c.05.04.095.06.136.06.041 0 .086-.02.136-.06l5.43-6.105a.208.208 0 00.058-.15.208.208 0 00-.057-.151L11.63 4.059A.171.171 0 0011.496 4z"
            transform="translate(.771)"
            fill="url(#uploadcheckicongradient)"
            fillRule="evenodd"
        />
    </svg>
)

export const ErrorIcon = ({ className }: Props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16" className={className}>
        <defs>
            <linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id="uploaderroricongradient">
                <stop stopColor={giphyRed} offset="0%" />
                <stop stopColor={giphyPink} offset="100%" />
            </linearGradient>
        </defs>
        <path
            d="M12 4a8 8 0 110 16 8 8 0 010-16zm0 10.864c-.37 0-.685.13-.945.39-.26.261-.39.576-.39.946s.13.685.39.945c.26.26.575.39.945.39s.685-.13.945-.39c.26-.26.39-.575.39-.945s-.13-.685-.39-.945c-.26-.26-.575-.39-.945-.39zm1-7.328h-2V13.2h2V7.536z"
            transform="translate(-3.333 -4)"
            fill="url(#uploaderroricongradient)"
            fillRule="evenodd"
        />
    </svg>
)

export const ClockIcon = ({ className }: Props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16" className={className}>
        <defs>
            <linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id="pendingicongradient">
                <stop stopColor={giphyRed} offset="0%" />
                <stop stopColor={giphyYellow} offset="100%" />
            </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
            <circle fill="url(#pendingicongradient)" cx="8" cy="8" r="8" />
            <path
                d="M8 14a5.88 5.88 0 002.335-.475 6.017 6.017 0 001.913-1.277 6.017 6.017 0 001.277-1.913A5.88 5.88 0 0014 8a5.88 5.88 0 00-.475-2.335 6.017 6.017 0 00-1.277-1.913 6.017 6.017 0 00-1.913-1.277A5.88 5.88 0 008 2a5.9 5.9 0 00-2.338.475 6.025 6.025 0 00-1.91 1.277 6.017 6.017 0 00-1.277 1.913A5.88 5.88 0 002 8c0 .816.158 1.595.475 2.335.316.74.742 1.378 1.277 1.913.535.535 1.173.961 1.913 1.277A5.88 5.88 0 008 14zm2.35-4L7.424 8.486a6.114 6.114 0 01-.156-.117A.777.777 0 017 7.774V4h.918l.838 3.356L11 9.406l-.65.594z"
                fill="#000"
                fillRule="nonzero"
            />
        </g>
    </svg>
)
